import React from "react";
import { Link } from "react-router-dom";

import {
  HABERDASHERY_SHOP_KEY,
  READY_MADE_SHOP_KEY,
  SHOP_PATHS,
  TEXTILE_SHOP_KEY,
} from "../../constants/shopMeta";

import "./HomeFeaturedCategories.css";

const DEPARTMENTS = [
  {
    key: READY_MADE_SHOP_KEY,
    label: "Ready-Made",
    tagline:
      "A new range of high-quality vintage reproduction clothing available in ready-to-wear or made-to-measure options.",
    to: SHOP_PATHS[READY_MADE_SHOP_KEY],
  },
  {
    key: TEXTILE_SHOP_KEY,
    label: "Textiles",
    tagline:
      "A large collection of vintage and contemporary suiting, shirting and other fabrics, available to purchase online or in person by appointment.",
    to: SHOP_PATHS[TEXTILE_SHOP_KEY],
  },
  {
    key: HABERDASHERY_SHOP_KEY,
    label: "Haberdashery",
    tagline:
      "A large selection of mostly vintage buttons, buckles, braids and assorted trimmings, available from our Waterloo Road shop or online.",
    to: SHOP_PATHS[HABERDASHERY_SHOP_KEY],
  },
];

export default function HomeFeaturedCategories() {
  return (
    <nav className="home-dept-strip" aria-label="Shop departments">
      <ul className="home-dept-strip__list">
        {DEPARTMENTS.map((dept, idx) => (
          <li className="home-dept-strip__item" key={dept.key}>
            <Link to={dept.to} className="home-dept-strip__link">
              <span className="home-dept-strip__index" aria-hidden="true">
                {String(idx + 1).padStart(2, "0")}
              </span>

              <span className="home-dept-strip__text">
                <span className="home-dept-strip__label">{dept.label}</span>

                <span className="home-dept-strip__tagline">{dept.tagline}</span>
              </span>

              <span className="home-dept-strip__arrow" aria-hidden="true">
                →
              </span>
            </Link>
          </li>
        ))}
      </ul>

      <div className="home-dept-strip__all-wrap">
        <Link to="/shop" className="home-dept-strip__all">
          View all departments
        </Link>
      </div>
    </nav>
  );
}
